import script from "./PetCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PetCard.vue?vue&type=script&setup=true&lang=js"

import "./PetCard.vue?vue&type=style&index=0&id=83404d80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83404d80"]])

export default __exports__